import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Doctor } from '../../types/doctor'

export const doctorService = {
  async list(params?: { status?: string; search?: string; page?: number; per_page?: number }) {
    const { data } = await apiClient.get<ApiPaginatedResponse<Doctor> | ApiSuccessResponse<Doctor[]>>(
      '/doctors',
      { params },
    )
    return data
  },

  async show(id: string) {
    const { data } = await apiClient.get<ApiSuccessResponse<Doctor>>(`/doctors/${id}`)
    return data
  },

  async approve(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Doctor>>(`/doctors/${id}/approve`)
    return data
  },

  async reject(id: string, rejection_reason?: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Doctor>>(`/doctors/${id}/reject`, {
      rejection_reason,
    })
    return data
  },

  async disable(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Doctor>>(`/doctors/${id}/disable`)
    return data
  },

  async enable(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Doctor>>(`/doctors/${id}/enable`)
    return data
  },
}
